import { render, staticRenderFns } from "./CategoriesTab.vue?vue&type=template&id=17d96594"
import script from "./CategoriesTab.vue?vue&type=script&lang=ts"
export * from "./CategoriesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports